import React from "react";
import heroimg from "../assets/hero.jpg";

const Hero = () => {
  const styles = {
    hero: {
      background: 'radial-gradient(circle at top left, #dcfce7, #eff6ff)',
      padding: '3.5rem 0 3rem',
      overflow: 'hidden',
    },
    leftContent: {
      maxWidth: '600px',
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.2rem 0.9rem',
      borderRadius: '999px',
      background: 'rgba(22, 163, 74, 0.06)',
      border: '1px solid rgba(22, 163, 74, 0.2)',
      fontSize: '0.78rem',
      fontWeight: 500,
      color: '#116530',
      marginBottom: '1rem',
    },
    badgeDot: {
      width: '8px',
      height: '8px',
      borderRadius: '999px',
      background: '#22c55e',
    },
    heroTitle: {
      fontSize: 'clamp(2.2rem, 3vw + 1.4rem, 3.2rem)',
      lineHeight: 1.1,
      fontWeight: 800,
      margin: '0 0 1rem',
      letterSpacing: '-0.03em',
    },
    heroTitleSpan: {
      background: 'linear-gradient(120deg, #116530, #1b9c85)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent',
    },
    heroSubtitle: {
      fontSize: '1rem',
      maxWidth: '32rem',
      color: '#4b5563',
      marginBottom: '1.7rem',
    },
    heroActions: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.75rem',
      alignItems: 'center',
      marginBottom: '1.3rem',
    },
    btnPrimary: {
      borderRadius: '999px',
      padding: '0.7rem 1.3rem',
      fontSize: '0.92rem',
      fontWeight: 600,
      cursor: 'pointer',
      border: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.4rem',
      textDecoration: 'none',
      background: '#116530',
      color: '#ffffff',
      boxShadow: '0 10px 25px rgba(22, 163, 74, 0.35)',
      transition: 'background 0.3s ease',
    },
    btnGhost: {
      borderRadius: '999px',
      padding: '0.7rem 1.3rem',
      fontSize: '0.92rem',
      fontWeight: 600,
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.4rem',
      textDecoration: 'none',
      background: 'transparent',
      color: '#116530',
      border: '1px solid rgba(148, 163, 184, 0.7)',
      transition: 'background 0.3s ease',
    },
    heroMeta: {
      display: 'flex',
      gap: '1.5rem',
      flexWrap: 'wrap',
      fontSize: '0.8rem',
      color: '#4b5563',
    }
  };

  return (
    <section style={styles.hero}>
      <div className="container grid-2">
        <div style={styles.leftContent}>
          <div style={styles.badge}>
            <span style={styles.badgeDot}></span>
            Transforming waste into opportunity
          </div>

          <h1 style={styles.heroTitle}>
            <span style={styles.heroTitleSpan}>Transforming Waste,</span> Restoring Earth
          </h1>

          <p style={styles.heroSubtitle}>
            Turning Industrial, Construction & Plastic Waste into High-Strength, High-Performance Building Materials.
          </p>

          <div style={styles.heroActions}>
            <a href="#contact" style={styles.btnPrimary}>Talk to us →</a>
            <a href="#products" style={styles.btnGhost}>View products</a>
          </div>

          {/* <div style={styles.heroMeta}>
            <span><strong style={{color: '#111827'}}>Eco-friendly</strong> materials</span>
            <span><strong style={{color: '#111827'}}>Industrial & plastic waste</strong> recycled</span>
          </div> */}
        </div>

        <div>
          <img src={heroimg} alt="Sustainable Material" className="hero-image" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
